import { Component, OnInit } from '@angular/core';
import { AuthStore } from '@lemsar/storage/stores/auth.store';
import { Router } from '@angular/router';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    21/07/2018
 */
@Component({
    selector: 'lemsar-sign-out-page',
    template: ``,
})
export class SignOutPage implements OnInit {
    public constructor(private auth: AuthStore, private router: Router) {}

    public ngOnInit(): void {
        this.auth.logout();
        this.router.navigate(['/']);
    }
}



// WEBPACK FOOTER //
// ./src/lemsar/auth/views/pages/sign-out.page.ts